var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import Expand from "@irati/ui/src/Expander";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import { Label2 } from "@irati/ui/src/Labels";
var MAX_RECIPIENTS_SHOWN = 3;
var RecipientList = /** @class */ (function (_super) {
    __extends(RecipientList, _super);
    function RecipientList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userLi = function (user) {
            return React.createElement("li", { key: user.uuid },
                React.createElement(Label2, null, firstnameLastname(user)));
        };
        return _this;
    }
    RecipientList.prototype.render = function () {
        var _this = this;
        var recipients = this.props.recipients;
        var minimizedRecipients = recipients.slice(0, MAX_RECIPIENTS_SHOWN);
        if (recipients.length > MAX_RECIPIENTS_SHOWN + 1) {
            return (React.createElement(Expand, { showText: React.createElement(React.Fragment, null,
                    minimizedRecipients.map(function (user) { return _this.userLi(user); }),
                    recipients.length > MAX_RECIPIENTS_SHOWN && React.createElement("li", null,
                        "and ",
                        recipients.length - MAX_RECIPIENTS_SHOWN,
                        " others")), hideText: recipients.map(function (user) { return _this.userLi(user); }) }));
        }
        return recipients.map(function (user) { return _this.userLi(user); });
    };
    RecipientList.defaultProps = {
        id: "rewardRecipientsListSummary"
    };
    return RecipientList;
}(PureComponent));
export default RecipientList;
